import { IconPropsType } from "./type";

export const Logo = ({ size: size = 24 }: IconPropsType) => (
  <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1105.92 1474.56"
  >
    <defs>
      <linearGradient
        id="_Оранжевый_желтый"
        data-name="Оранжевый, желтый"
        x1="0"
        y1="1013.8"
        x2="552.96"
        y2="1013.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ffef26" />
        <stop offset=".02" stopColor="#fee921" />
        <stop offset=".1" stopColor="#fdd70e" />
        <stop offset=".19" stopColor="#fdcb03" />
        <stop offset=".28" stopColor="#fdc800" />
        <stop offset=".67" stopColor="#f18f34" />
        <stop offset=".89" stopColor="#e95f32" />
        <stop offset="1" stopColor="#e3312d" />
      </linearGradient>
      <linearGradient
        id="_Оранжевый_желтый-2"
        data-name="Оранжевый, желтый"
        y1="875.56"
        x2="1105.92"
        y2="875.56"
        xlinkHref="#_Оранжевый_желтый"
      />
      <linearGradient
        id="_Оранжевый_желтый-3"
        data-name="Оранжевый, желтый"
        x1=".33"
        y1="362.66"
        x2="736.71"
        y2="362.66"
        xlinkHref="#_Оранжевый_желтый"
      />
      <linearGradient
        id="_Оранжевый_желтый-4"
        data-name="Оранжевый, желтый"
        x1="552.96"
        y1="276.48"
        x2="1105.92"
        y2="276.48"
        xlinkHref="#_Оранжевый_желтый"
      />
      <linearGradient
        id="_Оранжевый_желтый-5"
        data-name="Оранжевый, желтый"
        x1=".08"
        y1="645.12"
        x2="1105.92"
        y2="645.12"
        xlinkHref="#_Оранжевый_желтый"
      />
      <linearGradient
        id="_Оранжевый_желтый-6"
        data-name="Оранжевый, желтый"
        y1="276.36"
        y2="276.36"
        xlinkHref="#_Оранжевый_желтый"
      />
      <filter
        id="luminosity-invert"
        x="-2.12"
        y="-2.12"
        width="1110.24"
        height="1478.88"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feColorMatrix
          result="cm"
          values="-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
        />
      </filter>
      <mask
        id="mask"
        x="-2.12"
        y="-2.12"
        width="1110.24"
        height="1478.88"
        maskUnits="userSpaceOnUse"
      >
        <g filter="url(#luminosity-invert)">
          <image
          //...
          />
        </g>
      </mask>
    </defs>
    <g style={{ isolation: "isolate" }}>
      <g id="_Слой_2" data-name="Слой 2">
        <g id="_Слой_1-2" data-name="Слой 1">
          <g id="Logo">
            <image
            //...
            />
            <g>
              <g>
                <path
                  fill="url(#_Оранжевый_желтый)"
                  d="M477.92,1100.84c-83.56-11.31-161.22-41.29-228.56-85.69-9.58-6.31-19.01-12.94-28.18-19.82-11.31-8.44-22.2-17.29-32.85-26.62-16.79-14.75-32.69-30.47-47.51-47.1C55.46,826.24,2.62,700.99.08,563.45v-3.19c-.08-2.38-.08-4.83-.08-7.21v843.12c0,43.34,35.06,78.4,78.4,78.4h231.18c32.6,0,59.06-26.46,59.06-59.06v-125.26h.08c0-80.2,51.28-148.36,122.88-173.59,19.17-6.88,39.81-10.57,61.36-10.57v-.16c-25.48,0-50.46-1.72-75.04-5.08ZM.08,1300.73v-3.19c.08,2.38.16,4.67.25,7.05-.08-1.31-.16-2.54-.25-3.85ZM.08,1283.19v-3.19c.08-1.31.16-2.62.25-3.93-.08,2.38-.16,4.75-.25,7.13Z"
                />
                <path
                  fill="url(#_Оранжевый_желтый-2)"
                  d="M1105.92,1290.24v127.22c0,31.54-25.56,57.1-57.1,57.1h-252.81c-32.44,0-58.74-26.3-58.74-58.74v-125.58h-.08c0-1.88,0-3.69-.16-5.57-.08-1.8-.16-3.6-.25-5.49-.08-3.03-.41-6.06-.74-9.01,0-.25,0-.49-.08-.74-.08-.98-.16-1.97-.33-2.95-.16-.98-.25-1.97-.41-2.95-.08-.74-.16-1.47-.33-2.21-.66-4.1-1.39-8.19-2.38-12.21-.08-.33-.08-.66-.25-.98-.08-.74-.33-1.47-.49-2.13-.08-.33-.16-.66-.25-.98s-.16-.66-.25-.98c0-.16-.08-.25-.08-.41-.08-.16-.08-.25-.16-.41,0-.16-.08-.41-.16-.57,0-.08,0-.25-.08-.33,0-.16,0-.25-.08-.41-.25-1.07-.57-2.05-.9-3.11-.25-1.07-.57-2.13-.98-3.2-1.64-5.57-3.6-10.98-5.9-16.3-2.21-5.32-4.67-10.57-7.37-15.56-.82-1.64-1.72-3.28-2.7-4.83-.98-1.72-1.97-3.36-2.95-5-.25-.49-.49-.98-.82-1.39-.25-.33-.41-.66-.66-.98-.08-.25-.25-.49-.41-.66-.41-.66-.82-1.31-1.23-1.88-.66-.98-1.23-1.88-1.88-2.79-3.03-4.51-6.39-8.93-9.83-13.11-1.64-2.05-3.28-4.01-5.08-5.9-.25-.33-.49-.57-.82-.9-.9-1.07-1.88-2.13-2.95-3.11-.82-.98-1.72-1.88-2.7-2.79-.57-.65-1.23-1.23-1.88-1.88-4.01-4.01-8.27-7.78-12.7-11.31-1.88-1.56-3.85-3.11-5.82-4.51-.16-.16-.41-.33-.66-.49-1.97-1.47-3.93-2.95-5.98-4.26-.66-.49-1.39-.98-2.13-1.47-1.15-.74-2.38-1.56-3.6-2.29-.66-.49-1.39-.9-2.13-1.31-.57-.41-1.15-.74-1.8-1.07-1.8-1.07-3.6-2.13-5.41-3.11-1.47-.82-3.03-1.64-4.59-2.38-.74-.49-1.56-.82-2.29-1.15-.98-.57-2.05-1.06-3.03-1.47-.82-.49-1.72-.9-2.62-1.23-.08-.08-.16-.16-.33-.16-.25-.16-.49-.25-.74-.33,0-.08-.08-.08-.16-.08-.08-.08-.25-.08-.33-.16-.08,0-.16-.08-.33-.08-.66-.41-1.31-.66-2.05-.9-.33-.16-.74-.33-1.15-.49-.16-.16-.41-.25-.66-.25-.9-.49-1.88-.82-2.87-1.15-.65-.33-1.31-.57-2.05-.82-1.23-.49-2.38-.9-3.52-1.31-.66-.25-1.39-.49-2.13-.74-2.05-.74-4.18-1.39-6.31-2.05-2.46-.74-4.83-1.47-7.29-2.05-2.95-.82-5.9-1.47-8.93-2.05-2.95-.66-5.9-1.15-8.93-1.64h-.16c-2.79-.41-5.57-.82-8.44-1.07-6.47-.74-12.94-1.07-19.58-1.07v-.16c-25.48,0-50.46-1.72-75.04-5.08-83.56-11.31-161.22-41.29-228.56-85.69-9.58-6.31-19.01-12.94-28.18-19.82-11.31-8.44-22.2-17.29-32.85-26.62-16.79-14.75-32.69-30.47-47.51-47.1C55.46,826.24,2.62,700.99.08,563.45c.08,1.31.16,2.54.25,3.85-.08-2.38-.16-4.67-.25-7.04-.08-2.38-.08-4.83-.08-7.21v-.33c0-2.29,0-4.59.08-6.8.08-2.38.16-4.75.25-7.13,7.46-146.06,128.21-262.23,276.15-262.23,81.84,0,155.4,35.55,206.11,92.08,3.11,3.52,6.14,7.04,9.01,10.73-71.6,25.23-122.88,93.47-122.88,173.67s51.28,148.44,122.88,173.67c19.17,6.88,39.81,10.57,61.36,10.57,43.42,0,85.61,5,126.16,14.5,112.39,26.13,211.6,86.67,285.98,169.82,87.57,97.81,140.82,227,140.82,368.64Z"
                />
                <path
                  fill="url(#_Оранжевый_желтый-3)"
                  d="M736.71,540.92c-6.14-96.09-86.1-172.11-183.75-172.11-21.54,0-42.19,3.69-61.36,10.57-2.87-3.69-5.9-7.21-9.01-10.73-50.71-56.53-124.27-92.08-206.11-92.08C128.53,276.56,7.78,392.72.33,538.79,7.78,341.85,169.82,184.4,368.64,184.4c136.4,0,255.51,74.14,319.16,184.24,29.49,50.95,46.94,109.61,48.91,172.28Z"
                />
                <path
                  fill="url(#_Оранжевый_желтый-4)"
                  d="M921.6,0c101.8,0,184.32,82.52,184.32,184.32v368.64C1105.92,247.56,858.36,0,552.96,0h368.64Z"
                />
                <path
                  fill="url(#_Оранжевый_желтый-5)"
                  d="M1105.92,552.96v737.28c0-141.64-53.25-270.83-140.82-368.64-74.38-83.15-173.59-143.69-285.98-169.82-40.55-9.5-82.74-14.5-126.16-14.5,97.65,0,177.6-76.02,183.75-172.11.08-.33.08-.57.08-.9.08-1.23.16-2.38.25-3.6.08-2.54.16-5.08.16-7.62s-.08-5.08-.16-7.62c-.08-1.23-.16-2.38-.25-3.6,0-.33,0-.57-.08-.9-1.97-62.67-19.42-121.32-48.91-172.28-63.65-110.1-182.76-184.24-319.16-184.24C169.82,184.4,7.78,341.85.33,538.79c-.08,1.31-.16,2.62-.25,3.93C5.57,242.07,251,0,552.96,0s552.96,247.56,552.96,552.96Z"
                />
                <path
                  fill="url(#_Оранжевый_желтый-6)"
                  d="M552.96,0C251,0,5.57,242.07.08,542.72v3.2c-.08,2.21-.08,4.51-.08,6.8V184.32C0,82.49,82.49,0,184.32,0h368.64Z"
                />
              </g>
              <g mask="url(#mask)">
                <g style={{ mixBlendMode: "screen", opacity: 0.52 }}>
                  <g>
                    <path
                      fill="#fff"
                      d="M477.92,1100.84c-83.56-11.31-161.22-41.29-228.56-85.69-9.58-6.31-19.01-12.94-28.18-19.82-11.31-8.44-22.2-17.29-32.85-26.62-16.79-14.75-32.69-30.47-47.51-47.1C55.46,826.24,2.62,700.99.08,563.45v-3.19c-.08-2.38-.08-4.83-.08-7.21v843.12c0,43.34,35.06,78.4,78.4,78.4h231.18c32.6,0,59.06-26.46,59.06-59.06v-125.26h.08c0-80.2,51.28-148.36,122.88-173.59,19.17-6.88,39.81-10.57,61.36-10.57v-.16c-25.48,0-50.46-1.72-75.04-5.08ZM.08,1300.73v-3.19c.08,2.38.16,4.67.25,7.05-.08-1.31-.16-2.54-.25-3.85ZM.08,1283.19v-3.19c.08-1.31.16-2.62.25-3.93-.08,2.38-.16,4.75-.25,7.13Z"
                    />
                    <path
                      fill="#fff"
                      d="M1105.92,1290.24v127.22c0,31.54-25.56,57.1-57.1,57.1h-252.81c-32.44,0-58.74-26.3-58.74-58.74v-125.58h-.08c0-1.88,0-3.69-.16-5.57-.08-1.8-.16-3.6-.25-5.49-.08-3.03-.41-6.06-.74-9.01,0-.25,0-.49-.08-.74-.08-.98-.16-1.97-.33-2.95-.16-.98-.25-1.97-.41-2.95-.08-.74-.16-1.47-.33-2.21-.66-4.1-1.39-8.19-2.38-12.21-.08-.33-.08-.66-.25-.98-.08-.74-.33-1.47-.49-2.13-.08-.33-.16-.66-.25-.98s-.16-.66-.25-.98c0-.16-.08-.25-.08-.41-.08-.16-.08-.25-.16-.41,0-.16-.08-.41-.16-.57,0-.08,0-.25-.08-.33,0-.16,0-.25-.08-.41-.25-1.07-.57-2.05-.9-3.11-.25-1.07-.57-2.13-.98-3.2-1.64-5.57-3.6-10.98-5.9-16.3-2.21-5.32-4.67-10.57-7.37-15.56-.82-1.64-1.72-3.28-2.7-4.83-.98-1.72-1.97-3.36-2.95-5-.25-.49-.49-.98-.82-1.39-.25-.33-.41-.66-.66-.98-.08-.25-.25-.49-.41-.66-.41-.66-.82-1.31-1.23-1.88-.66-.98-1.23-1.88-1.88-2.79-3.03-4.51-6.39-8.93-9.83-13.11-1.64-2.05-3.28-4.01-5.08-5.9-.25-.33-.49-.57-.82-.9-.9-1.07-1.88-2.13-2.95-3.11-.82-.98-1.72-1.88-2.7-2.79-.57-.65-1.23-1.23-1.88-1.88-4.01-4.01-8.27-7.78-12.7-11.31-1.88-1.56-3.85-3.11-5.82-4.51-.16-.16-.41-.33-.66-.49-1.97-1.47-3.93-2.95-5.98-4.26-.66-.49-1.39-.98-2.13-1.47-1.15-.74-2.38-1.56-3.6-2.29-.66-.49-1.39-.9-2.13-1.31-.57-.41-1.15-.74-1.8-1.07-1.8-1.07-3.6-2.13-5.41-3.11-1.47-.82-3.03-1.64-4.59-2.38-.74-.49-1.56-.82-2.29-1.15-.98-.57-2.05-1.06-3.03-1.47-.82-.49-1.72-.9-2.62-1.23-.08-.08-.16-.16-.33-.16-.25-.16-.49-.25-.74-.33,0-.08-.08-.08-.16-.08-.08-.08-.25-.08-.33-.16-.08,0-.16-.08-.33-.08-.66-.41-1.31-.66-2.05-.9-.33-.16-.74-.33-1.15-.49-.16-.16-.41-.25-.66-.25-.9-.49-1.88-.82-2.87-1.15-.65-.33-1.31-.57-2.05-.82-1.23-.49-2.38-.9-3.52-1.31-.66-.25-1.39-.49-2.13-.74-2.05-.74-4.18-1.39-6.31-2.05-2.46-.74-4.83-1.47-7.29-2.05-2.95-.82-5.9-1.47-8.93-2.05-2.95-.66-5.9-1.15-8.93-1.64h-.16c-2.79-.41-5.57-.82-8.44-1.07-6.47-.74-12.94-1.07-19.58-1.07v-.16c-25.48,0-50.46-1.72-75.04-5.08-83.56-11.31-161.22-41.29-228.56-85.69-9.58-6.31-19.01-12.94-28.18-19.82-11.31-8.44-22.2-17.29-32.85-26.62-16.79-14.75-32.69-30.47-47.51-47.1C55.46,826.24,2.62,700.99.08,563.45c.08,1.31.16,2.54.25,3.85-.08-2.38-.16-4.67-.25-7.04-.08-2.38-.08-4.83-.08-7.21v-.33c0-2.29,0-4.59.08-6.8.08-2.38.16-4.75.25-7.13,7.46-146.06,128.21-262.23,276.15-262.23,81.84,0,155.4,35.55,206.11,92.08,3.11,3.52,6.14,7.04,9.01,10.73-71.6,25.23-122.88,93.47-122.88,173.67s51.28,148.44,122.88,173.67c19.17,6.88,39.81,10.57,61.36,10.57,43.42,0,85.61,5,126.16,14.5,112.39,26.13,211.6,86.67,285.98,169.82,87.57,97.81,140.82,227,140.82,368.64Z"
                    />
                    <path
                      fill="#fff"
                      d="M736.71,540.92c-6.14-96.09-86.1-172.11-183.75-172.11-21.54,0-42.19,3.69-61.36,10.57-2.87-3.69-5.9-7.21-9.01-10.73-50.71-56.53-124.27-92.08-206.11-92.08C128.53,276.56,7.78,392.72.33,538.79,7.78,341.85,169.82,184.4,368.64,184.4c136.4,0,255.51,74.14,319.16,184.24,29.49,50.95,46.94,109.61,48.91,172.28Z"
                    />
                    <path
                      fill="#fff"
                      d="M921.6,0c101.8,0,184.32,82.52,184.32,184.32v368.64C1105.92,247.56,858.36,0,552.96,0h368.64Z"
                    />
                    <path
                      fill="#fff"
                      d="M1105.92,552.96v737.28c0-141.64-53.25-270.83-140.82-368.64-74.38-83.15-173.59-143.69-285.98-169.82-40.55-9.5-82.74-14.5-126.16-14.5,97.65,0,177.6-76.02,183.75-172.11.08-.33.08-.57.08-.9.08-1.23.16-2.38.25-3.6.08-2.54.16-5.08.16-7.62s-.08-5.08-.16-7.62c-.08-1.23-.16-2.38-.25-3.6,0-.33,0-.57-.08-.9-1.97-62.67-19.42-121.32-48.91-172.28-63.65-110.1-182.76-184.24-319.16-184.24C169.82,184.4,7.78,341.85.33,538.79c-.08,1.31-.16,2.62-.25,3.93C5.57,242.07,251,0,552.96,0s552.96,247.56,552.96,552.96Z"
                    />
                    <path
                      fill="#fff"
                      d="M552.96,0C251,0,5.57,242.07.08,542.72v3.2c-.08,2.21-.08,4.51-.08,6.8V184.32C0,82.49,82.49,0,184.32,0h368.64Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
